import React from "react";
import { useParams } from "react-router-dom";
import TopSection from "../../../sublicenseAllCourses/components/top-section/TopSection";
import { VehicleAndLicenseTextdata } from "../../../../../dataString/dataForLicenseAndVehicles";

const ForNoSubcategory = ({ Type }) => {
  const { LicenseTypeId } = useParams();

  const TypeName = Type?.LicenseTypeName
    ? Type?.LicenseTypeName
    : Type?.VehicleTypeName;
  let headingText;
  let headingText2;
  let subHeading;
  let headingForListing;
  let subHeadingForListing;
  console.log("TypeName===>", TypeName);
  switch (TypeName) {
    case "L":
      headingText = VehicleAndLicenseTextdata?.vehicleTypeL?.headingText;
      headingText2 = VehicleAndLicenseTextdata?.vehicleTypeL?.headingText2;
      subHeading = VehicleAndLicenseTextdata?.vehicleTypeL?.subHeading;
      headingForListing =
        VehicleAndLicenseTextdata?.vehicleTypeL?.headingForListing;
      subHeadingForListing =
        VehicleAndLicenseTextdata?.vehicleTypeL?.subHeadingForListing;
      break;
    case "M":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeM?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeM?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeM?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeM?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeM?.subHeadingForListing;
      break;
    case "N":
        headingText = VehicleAndLicenseTextdata?.vehicleTyeN?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTyeN?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTyeN?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTyeN?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTyeN?.subHeadingForListing;
      break;
    case "B":
      headingText = VehicleAndLicenseTextdata?.vehicleTypeB?.headingText;
      headingText2 = VehicleAndLicenseTextdata?.vehicleTypeB?.headingText2;
      subHeading = VehicleAndLicenseTextdata?.vehicleTypeB?.subHeading;
      headingForListing =
        VehicleAndLicenseTextdata?.vehicleTypeB?.headingForListing;
      subHeadingForListing =
        VehicleAndLicenseTextdata?.vehicleTypeB?.subHeadingForListing;
    break;
    // case "B":
    //   headingText =
    //     "Class B License – Drive with Confidence and Responsibility Become a Certified School Bus Driver with Expert Training";
    //   subHeading =
    //     "At Vehicle Learning Innovation, We help you find the best training institutes to ensure you pass your Class B tests with ease. Whether you’re starting a career in school bus driving or upgrading your license, Our Partnered training institute provides expert guidance and access to top-rated courses.";
    //   break;
    case "C":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeC?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeC?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeC?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeC?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeC?.subHeadingForListing;
      break;
    case "T":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeT?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeT?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeT?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeT?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeT?.subHeadingForListing;
      break;
    case "Ambulance":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeAmbulance?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeAmbulance?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeAmbulance?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeAmbulance?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeAmbulance?.subHeadingForListing;
      break;
    case "School Bus":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeSchoolBus?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeSchoolBus?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeSchoolBus?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeSchoolBus?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeSchoolBus?.subHeadingForListing;
      break;
    case "D":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeD?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeD?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeD?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeD?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeD?.subHeadingForListing;
      break;
    case "F":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeF?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeF?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeF?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeF?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeF?.subHeadingForListing;
      break;
    case "A":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeA?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeA?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeA?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeA?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeA?.subHeadingForListing;
      break;
    case "E":
        headingText = VehicleAndLicenseTextdata?.vehicleTypeE?.headingText;
        headingText2 = VehicleAndLicenseTextdata?.vehicleTypeE?.headingText2;
        subHeading = VehicleAndLicenseTextdata?.vehicleTypeE?.subHeading;
        headingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeE?.headingForListing;
        subHeadingForListing =
          VehicleAndLicenseTextdata?.vehicleTypeE?.subHeadingForListing;
      break;
    // case "Industrial Machinery":
    //   headingText =
    //     "Heavy equipment operators operate heavy equipment used in the construction and maintenance of roads, bridges, airports, gas and oil pipelines, tunnels, buildings and other structures, in surface mining and quarrying activities and in material handling work. They are employed by construction, pipeline and logging companies, and by heavy equipment contractors.";
    //   headingForListing =
    //     "industrial Machinery -  license type ";
    //   break;
    default:
      headingText =
        "Heading Vehicle Learning Innovation Offers A-Z Driving Courses for all Vehicles";
      subHeading =
        "Para Discover comprehensive A-Z driving courses for all vehicle types at Vehicle Learning Innovation, your centralized hub for mastering the road.";
      break;
  }

  const HeadingText =
    " Vehicle Learning Innovation Offers A-Z Driving Courses for all Vehicles";
  const paraText =
    " Discover comprehensive A-Z driving courses for all vehicle types at Vehicle Learning Innovation, your centralized hub for mastering the road.";
  return (
    <>
      <TopSection headingText={headingText} headingText2={headingText2} paraText={subHeading} />

      <div className="flex flex-col items-center bg-backgroundWhiteColor">
        <div className="flex w-full flex-col items-center  gap-2 bg-backgroundWhiteColor py-5">
          <div className="flex w-full justify-center">
            <div className="w-full">
            {headingForListing && (
              <div className="w-full content-center">
                <h2 className="Regularfont mx-auto w-[90%] font-black font-segoe-ui text-center text-4xs text-black sm:w-[90%] md:w-[80%] md:text-3xs lg:text-2xs xl:text-base pb-5">
                  {headingForListing && headingForListing}
                </h2>

                <p className="Regularfont mx-auto w-[90%] font-medium font-segoe-ui text-center text-4xs text-black sm:w-[90%] md:w-[80%]  md:text-3xs lg:text-2xs xl:text-base">
                   {subHeadingForListing && subHeadingForListing}
                </p>
              </div>
            )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForNoSubcategory;
